import { SystemActions } from "./action_types"
import { Action } from "./actions"

const accountReducer = (
  initialState: any,
  action: Action
): any => {
  switch (action.type) {
    case SystemActions.FETCH_SYSTEMS:
      return {
        ...initialState,
        systems: action.payload
      }

    case SystemActions.ASSIGN_USER_SYSTEMS:
      return {
        ...initialState,
        userSystems: action.payload
      }

    case SystemActions.SELECT_SYSTEM:
      console.log(action.payload)
      return {
        ...initialState,
        selectedSystem: action.payload
      }

    case SystemActions.CREATE_SYSTEM:
      return {
        ...initialState,
        systems: [...initialState.systems, action.payload],
        selectedSystem: action.payload.systemCode
      }

    case SystemActions.DELETE_SYSTEM:
      const updatedSystems = initialState.systems.filter((s:any) => s.systemCode !== action.payload)
      const selectedSystemCode = initialState.systems[0].systemCode
      return {
        ...initialState,
        systems: updatedSystems,
        selectedSystem: selectedSystemCode
      };


    default:
      return {
        ...initialState,
      }
  }
}

export default accountReducer